enum AggregatorsActionsEnum {
    AggregatorsList = 'AGGREGATORS/LIST',
    AggregatorsSet = 'AGGREGATORS/SET',
}

export default AggregatorsActionsEnum;
